import flickr_logo from '../../../img/flickr.png';
import FlickrFlow from '../../widgets/flickr/flickrflow';

export default function Flickr(props) {

    const text_es = `Participé por muchos años en una comunidad de fotógrafos agrupados en Flickr, en el grupo "La CSM".
    En este grupo aprendí fotografía hasta poder incluso enseñar técnica fotográfica e incluso hacer algunos pequeños trabajos.
    Todo ese trabajo se puede encontrar en mi cuenta de Flickr, y en este widget -que hice yo mismo- se pueden ver las últimas fotos que subí.`;
    const text_en = `I participated for many years in a community of photographers grouped in Flickr, in the group "La CSM".
    In this group I learned photography until I could even teach photographic technique and even do some small jobs.
    All that work can be found on my Flickr account, and in this widget -which I made myself- you can see the latest photos I uploaded.`;
    let text = text_es;

    switch(props.lang){
        case "en":
            text = text_en;
        default:
            break;
    }

    return (
        <article className='article' name='flickr'><img src={flickr_logo} width="32px" alt="flickr"/>
            <p>{text}</p>
            <FlickrFlow per_page={150}/>
        </article>);
}